import {
    usePermissions,
    useResourceContext,
    ReferenceInput,
    useLocaleState,
    required,
} from "react-admin";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { SimpleFormWithPermissions } from "../components/SimpleFormWithPermissions";
import { RaCreateView } from "../components/views/RaCreateView";
import { RaDateInput } from "../components/inputs/Ra/RaDateInput";
import { RaTextInput } from "../components/inputs/Ra/RaTextInput";
import { RaNumberInput } from "../components/inputs/Ra/RaNumberInput";
import { RaAutocompleteInput } from "../components/inputs/Ra/RaAutocompleteInput";
import { useState } from "react";

export const ArrivalCreate = (props) => {
    const [isMassProduct, setIsMassProduct] = useState(false);
    const [locale] = useLocaleState();
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }
    return (
        <RaCreateView
            mutationMode="pessimistic"
            actions={<ToolbarWithHistory back={true} />}
            transform={(data) => ({
                ...data,
                ...(isMassProduct ? { } : { defectQuantity: 0, quantity: 0}),
            })}
            {...props}
        >
            <SimpleFormWithPermissions>
                <ReferenceInput
                    source="product.id"
                    reference="products"
                    sort={{ field: "name", order: "ASC" }}
                >
                    <RaAutocompleteInput
                        label="equip.product"
                        validate={[required()]}
                        fullWidth
                        field="name"
                        optionText={({ name }) => name?.[locale] || ""}
                        inputText={(choice) => choice?.name?.[locale] || ""}
                        onChange={(event, value, reason) => {
                            if (props.onChange) props.onChange(event, value, reason);
                            setIsMassProduct(value?.isMassProduct);
                        }}
                    />
                </ReferenceInput>

                <ReferenceInput
                    source="supplier.id"
                    reference="suppliers"
                    sort={{ field: "name", order: "ASC" }}
                >
                    <RaAutocompleteInput
                        label="equip.supplier"
                        validate={[required()]}
                        fullWidth
                        field="name"
                    />
                </ReferenceInput>
                <RaNumberInput label="equip.purchasePrice" source="purchasePrice" required />
                <RaTextInput
                    label="equip.purchaseOrderNumber"
                    source="purchaseOrderNumber"
                    required
                />
                <RaDateInput label="equip.orderDate" source="orderDate" required />
                <RaDateInput label="equip.deliveryDate" source="deliveryDate" required />
                {isMassProduct && (
                    <>
                        <RaNumberInput label="equip.deliveredOk" source="quantity" required />
                        <RaNumberInput
                            label="equip.defectQuantity"
                            source="defectQuantity"
                            defaultValue={0}
                            required
                        />
                    </>
                )}
                <RaTextInput label="equip.comment" source="comment" multiline rows={3} />
            </SimpleFormWithPermissions>
        </RaCreateView>
    );
};
